import axios from "axios";
import { API_URL_SEARCH_BY_ADDRESS } from "../../config/config";
import { isoLanguageMap } from "../languages";

/**
 * Drop-in replacement for Geocode.fromAddress(address).
 *
 * Routes the geocoding call through the server-side /api/geocodeaddress
 * endpoint, avoiding react-geocode-place-id global state bugs and keeping
 * the server-side API key off the client.
 *
 * Returns a promise that resolves to the raw Google Geocoding response
 * { status, results } — same shape as Geocode.fromAddress().
 *
 * @param {string} address   Full address string to geocode
 * @param {string} language  Internal language code ("en" | "it")
 * @returns {Promise<{status: string, results: Array}>}
 */
export function geocodeAddress(address, language = "it") {
  return axios
    .get(API_URL_SEARCH_BY_ADDRESS, {
      params: {
        address,
        language: isoLanguageMap[language] ?? language,
      },
      // language goes straight to Google: keep the ISO code, don't map en → gb
      skipLangTransform: true,
    })
    .then((res) => res.data);
}

export function geocodeByPlaceId(placeId, language = "it") {
  return axios
    .get(API_URL_SEARCH_BY_ADDRESS, {
      params: {
        place_id: placeId,
        language: isoLanguageMap[language] ?? language,
      },
      // language goes straight to Google: keep the ISO code, don't map en → gb
      skipLangTransform: true,
    })
    .then((res) => res.data);
}